// extracted by mini-css-extract-plugin
export default {"linksWrapper":"DesktopMenu_linksWrapper__4DxC3","navLink":"DesktopMenu_navLink__GMjN-","logoutBtn":"DesktopMenu_logoutBtn__MivoD"};